import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Footer } from "@/components/Footer";

export const LegalLayout = ({ title, updated, testid, children }) => (
    <div className="min-h-screen bg-[#0B0F17] text-[#F9FAFB]">
        <header className="border-b border-white/[0.08] bg-[#0B0F17]/80 backdrop-blur-xl">
            <div className="max-w-3xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
                <Link to="/" data-testid="legal-logo" className="flex items-center gap-2.5">
                    <span className="status-dot h-2.5 w-2.5 rounded-full bg-emerald-500" aria-hidden="true" />
                    <span className="font-heading font-semibold text-lg tracking-tight">Kirenzo</span>
                </Link>
                <Link
                    to="/"
                    data-testid="legal-back-link"
                    className="inline-flex items-center gap-1.5 text-sm text-[#9CA3AF] hover:text-white transition-colors duration-200"
                >
                    <ArrowLeft className="h-4 w-4" aria-hidden="true" />
                    Zurück zur Startseite
                </Link>
            </div>
        </header>
        <main data-testid={testid} className="max-w-3xl mx-auto px-4 sm:px-6 py-14 sm:py-20">
            <h1 className="text-3xl sm:text-4xl font-semibold tracking-tight text-white">{title}</h1>
            <p className="mt-2 text-sm text-[#6B7280]">{updated}</p>
            <div className="mt-10 space-y-10">{children}</div>
        </main>
        <Footer />
    </div>
);

export const LegalSection = ({ title, testid, children }) => (
    <section data-testid={testid} aria-label={title}>
        <h2 className="text-xl sm:text-2xl font-medium text-white">{title}</h2>
        <div className="mt-3 text-sm sm:text-base text-[#9CA3AF] leading-relaxed space-y-3">{children}</div>
    </section>
);
